(function() {
    'use strict';
    
    // Debug flag - set to true if you need to troubleshoot
    const DEBUG = false;
    
    function log(message, data) {
        if (DEBUG) {
            console.log('[Skylit Blog]', message, data || '');
        }
    }
    
    // Check if already initialized to prevent double-initialization
    if (window.skylitBlogAnimationsInitialized) {
        log('Already initialized, skipping');
        return;
    }
    
    function initBlogAnimations() {
        log('Initialization starting...');
        
        // Mark as initialized
        window.skylitBlogAnimationsInitialized = true;
        
        // Add animate-ready class to enable animations
        // This is crucial - without it, content stays visible (our fallback)
        document.body.classList.add('animate-ready');
        log('Added animate-ready class to body');
        
        // FALLBACK: Detect and fix old article structure
        detectAndFixLegacyArticles();
        
        // Function to handle articles without the new wrapper structure
        function detectAndFixLegacyArticles() {
            // Find all TOCs on the page
            const allTocs = document.querySelectorAll('.skylit-toc');
            
            allTocs.forEach(toc => {
                // Check if this TOC is already inside a proper wrapper
                const hasProperWrapper = toc.closest('.skylit-article-with-toc');
                
                if (!hasProperWrapper) {
                    log('Standalone TOC detected - creating wrapper structure');
                    
                    // Get the parent container
                    const parent = toc.parentElement;
                    
                    // Create the main wrapper
                    const articleWrapper = document.createElement('div');
                    articleWrapper.className = 'skylit-article-with-toc';
                    
                    // Create the content wrapper
                    const contentWrapper = document.createElement('div');
                    contentWrapper.className = 'skylit-article-body';
                    
                    // Collect content BEFORE TOC (for articles like canvas intro)
                    const contentBefore = [];
                    let sibling = toc.previousSibling;
                    
                    while (sibling) {
                        const prev = sibling.previousSibling;
                        
                        // Collect element nodes and meaningful text nodes
                        if (sibling.nodeType === 1) {
                            // Skip if it's a container/wrapper element that shouldn't be moved
                            if (!sibling.classList.contains('container') && 
                                !sibling.id && 
                                !sibling.hasAttribute('data-section-id')) {
                                contentBefore.unshift(sibling);
                            }
                        } else if (sibling.nodeType === 3 && sibling.textContent.trim()) {
                            contentBefore.unshift(sibling);
                        }
                        
                        sibling = prev;
                    }
                    
                    // Insert the main wrapper before the TOC
                    parent.insertBefore(articleWrapper, toc);
                    
                    // Move the TOC into the main wrapper
                    articleWrapper.appendChild(toc);
                    
                    // Move content that was before TOC into content wrapper
                    contentBefore.forEach(node => {
                        contentWrapper.appendChild(node);
                    });
                    
                    // Collect all following siblings until we hit certain boundaries
                    let siblingAfter = articleWrapper.nextSibling;
                    const contentAfter = [];
                    
                    while (siblingAfter) {
                        const next = siblingAfter.nextSibling;
                        
                        // Stop if we hit another TOC or article wrapper
                        if (siblingAfter.nodeType === 1 && 
                            (siblingAfter.classList.contains('skylit-toc') || 
                             siblingAfter.classList.contains('skylit-article-with-toc'))) {
                            break;
                        }
                        
                        // Collect element nodes (skip text nodes with only whitespace)
                        if (siblingAfter.nodeType === 1) {
                            contentAfter.push(siblingAfter);
                        } else if (siblingAfter.nodeType === 3 && siblingAfter.textContent.trim()) {
                            contentAfter.push(siblingAfter);
                        }
                        
                        siblingAfter = next;
                    }
                    
                    // Move content that was after TOC into content wrapper
                    contentAfter.forEach(node => {
                        contentWrapper.appendChild(node);
                    });
                    
                    // Add the content wrapper to the main wrapper
                    articleWrapper.appendChild(contentWrapper);
                    
                    log('Legacy article structure auto-fixed - moved ' + contentBefore.length + ' elements before TOC and ' + contentAfter.length + ' after');
                } else {
                    // TOC is in a wrapper, but check if content wrapper exists
                    const wrapper = toc.closest('.skylit-article-with-toc');
                    const hasArticleBody = wrapper.querySelector('.skylit-article-body');
                    
                    if (!hasArticleBody) {
                        log('TOC in wrapper but no content wrapper - fixing');
                        
                        const contentWrapper = document.createElement('div');
                        contentWrapper.className = 'skylit-article-body';
                        
                        // Move all siblings after TOC into the content wrapper
                        let sibling = toc.nextElementSibling;
                        while (sibling) {
                            const next = sibling.nextElementSibling;
                            contentWrapper.appendChild(sibling);
                            sibling = next;
                        }
                        
                        wrapper.appendChild(contentWrapper);
                        log('Content wrapper added to existing structure');
                    }
                }
            });
        }
        
        // Check if elements exist before proceeding
        const animationElements = document.querySelectorAll('.fade-in-scroll, .slide-in-left, .scale-in');
        const statCounters = document.querySelectorAll('.skylit-stat-counter');
        const progressBars = document.querySelectorAll('.skylit-progress');
        const tocLinks = document.querySelectorAll('.skylit-toc a[href^="#"]');
        
        log('Found elements:', {
            animations: animationElements.length,
            counters: statCounters.length,
            progressBars: progressBars.length,
            tocLinks: tocLinks.length
        });
        
        if (animationElements.length === 0 && statCounters.length === 0 && progressBars.length === 0) {
            log('No blog animation elements found, but initializing other features');
        }
        
        // Intersection Observer for scroll animations
        if (animationElements.length > 0) {
            const observerOptions = {
                threshold: 0.1,
                rootMargin: '0px 0px -50px 0px'
            };

            const observer = new IntersectionObserver(function(entries) {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('visible');
                        log('Element became visible', entry.target);
                    }
                });
            }, observerOptions);

            // Observe all animation elements
            animationElements.forEach(el => {
                observer.observe(el);
            });
            
            log('Intersection observer initialized for', animationElements.length, 'elements');
        }

        // Animated Counters
        function animateCounters() {
            const counters = document.querySelectorAll('.skylit-stat-counter');
            counters.forEach(counter => {
                if (counter.classList.contains('animated')) return;
                
                const target = parseInt(counter.getAttribute('data-target'));
                if (isNaN(target)) {
                    log('Invalid counter target', counter);
                    return;
                }
                
                counter.classList.add('animated');
                const duration = 2000;
                const step = target / (duration / 16);
                let current = 0;

                const timer = setInterval(() => {
                    current += step;
                    if (current >= target) {
                        counter.textContent = target.toLocaleString();
                        clearInterval(timer);
                    } else {
                        counter.textContent = Math.floor(current).toLocaleString();
                    }
                }, 16);
                
                log('Counter animated', {target, element: counter});
            });
        }

        // Progress Bar Animation
        function animateProgressBars() {
            const progressBars = document.querySelectorAll('.skylit-progress-bar');
            progressBars.forEach(bar => {
                if (bar.classList.contains('animated')) return;
                
                const width = bar.getAttribute('data-width');
                if (!width) {
                    log('Progress bar missing data-width', bar);
                    return;
                }
                
                bar.classList.add('animated');
                setTimeout(() => {
                    bar.style.width = width + '%';
                }, 500);
                
                log('Progress bar animated', {width, element: bar});
            });
        }

        // Counter observer
        if (statCounters.length > 0) {
            const counterObserver = new IntersectionObserver(function(entries) {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        animateCounters();
                        counterObserver.unobserve(entry.target);
                    }
                });
            }, { threshold: 0.5 });

            statCounters.forEach(counter => {
                counterObserver.observe(counter);
            });
            
            log('Counter observer initialized');
        }

        // Progress bar observer
        if (progressBars.length > 0) {
            const progressObserver = new IntersectionObserver(function(entries) {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        animateProgressBars();
                        progressObserver.unobserve(entry.target);
                    }
                });
            }, { threshold: 0.5 });

            progressBars.forEach(progress => {
                progressObserver.observe(progress);
            });
            
            log('Progress bar observer initialized');
        }

        // Smooth scrolling for TOC links (with header offset)
        if (tocLinks.length > 0) {
            const HEADER_OFFSET = 100; // adjust to match your sticky header height

            tocLinks.forEach(anchor => {
                anchor.addEventListener('click', function (e) {
                    e.preventDefault();
                    const targetId = this.getAttribute('href');
                    const target = document.querySelector(targetId);
                    if (target) {
                        const rect = target.getBoundingClientRect();
                        const targetTop = rect.top + window.pageYOffset - HEADER_OFFSET;

                        window.scrollTo({
                            top: targetTop,
                            behavior: 'smooth'
                        });

                        log('Smooth scroll to', targetId);
                    }
                });
            });

            log('TOC smooth scrolling initialized');
        }

        // TOC scrollspy: highlight active section as you scroll
        if (tocLinks.length > 0) {
            const sectionMap = new Map();

            tocLinks.forEach(link => {
                const id = link.getAttribute('href').slice(1);
                const heading = document.getElementById(id);
                if (heading) {
                    sectionMap.set(heading, link);
                }
            });

            if (sectionMap.size > 0) {
                const observerOptions = {
                    root: null,
                    rootMargin: '-45% 0px -45% 0px', // centre of the viewport-ish
                    threshold: 0.1
                };

                const tocObserver = new IntersectionObserver(entries => {
                    let activeHeading = null;

                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            if (!activeHeading) {
                                activeHeading = entry.target;
                            } else if (entry.target.offsetTop < activeHeading.offsetTop) {
                                activeHeading = entry.target;
                            }
                        }
                    });

                    if (activeHeading) {
                        const activeLink = sectionMap.get(activeHeading);
                        if (activeLink) {
                            tocLinks.forEach(link => link.classList.remove('active'));
                            activeLink.classList.add('active');
                        }
                    }
                }, observerOptions);

                sectionMap.forEach((link, heading) => {
                    tocObserver.observe(heading);
                });

                log('TOC scrollspy initialized for', sectionMap.size, 'sections');
            }
        }

        // Reading progress indicator
        function updateReadingProgress() {
            const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
            const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            const scrolled = (winScroll / height) * 100;
            
            let progressBar = document.querySelector('.reading-progress');
            if (!progressBar) {
                progressBar = document.createElement('div');
                progressBar.className = 'reading-progress';
                document.body.appendChild(progressBar);
                log('Reading progress bar created');
            }
            progressBar.style.width = scrolled + '%';
        }

        // Only add scroll listener if we're on an article page
        if (document.querySelector('article') || document.querySelector('.blog-post') || document.querySelector('.article')) {
            window.addEventListener('scroll', updateReadingProgress);
            updateReadingProgress();
            log('Reading progress initialized');
        }
        
        log('✅ Initialization complete');
    }
    
    // Multiple initialization strategies for maximum compatibility
    
    // Strategy 1: If DOM is already loaded
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        log('DOM already loaded, initializing immediately');
        setTimeout(initBlogAnimations, 50);
    }
    
    // Strategy 2: DOMContentLoaded event
    if (document.readyState === 'loading') {
        log('Waiting for DOMContentLoaded');
        document.addEventListener('DOMContentLoaded', initBlogAnimations);
    }
    
    // Strategy 3: Window load event (Shopify themes often need this)
    window.addEventListener('load', function() {
        log('Window load event fired');
        setTimeout(initBlogAnimations, 100);
    });
    
    // Strategy 4: Delayed fallback for Shopify's async loading
    setTimeout(function() {
        if (!window.skylitBlogAnimationsInitialized) {
            log('Fallback initialization triggered after 500ms');
            initBlogAnimations();
        }
    }, 500);
    
    // Strategy 5: Extended fallback for very slow Shopify themes
    setTimeout(function() {
        if (!window.skylitBlogAnimationsInitialized) {
            log('Extended fallback initialization triggered after 1500ms');
            initBlogAnimations();
        }
    }, 1500);
    
})();